import BookDetails from '@/pages/Books/BookDetails';
import { ITicketData } from '@/types';

export default function BookTicket({ ticket }: { ticket: ITicketData }) {

  return <BookDetails bookId={ticket?.book_id} />;
}
